export default "__VITE_ASSET__Dkqvz6F___"